import {useState} from 'react';

/**
 * Hook to manage row selection in tables with checkboxes.
 * @param items Array of items with a unique id.
 * @param getId Function to get the id of each item (defaults to item.id)
 */
export function useTableSelection<T>(
  items: T[],
  getId: (item: T) => string = (item: any) => item.id,
) {
  const [isAllSelected, setIsAllSelected] = useState<boolean>(false);
  const [selectedIds, setSelectedIds] = useState<string[]>([]);

  const handleSelectAll = (checked: boolean) => {
    setIsAllSelected(checked);
    if (checked) {
      const allIds = items.map(getId);
      setSelectedIds(allIds);
    } else {
      setSelectedIds([]);
    }
  };

  const handleItemSelect = (id: string, isChecked: boolean) => {
    if (isChecked) {
      const newSelected = [...selectedIds, id];
      setSelectedIds(newSelected);
      if (newSelected.length === items.length) {
        setIsAllSelected(true);
      }
    } else {
      setSelectedIds(prev => prev.filter(itemId => itemId !== id));
      setIsAllSelected(false);
    }
  };

  return {
    isAllSelected,
    setIsAllSelected,
    selectedIds,
    setSelectedIds,
    handleSelectAll,
    handleItemSelect,
  };
}
